import { memo, useEffect, useRef } from 'react';

import Box from '@mui/material/Box';

import {
  ScaffolderFormPaper,
  ScaffolderInputHeader,
} from '../../../components';
import { ProjectPicker } from '../components';
import { Project } from '../types';
import { projectInputErrors } from '../validation';

export interface ProjectSectionProps {
  value: string;
  projects: Project[];
  loading: boolean;
  onChange: (value: string) => void;
  errors: string[];
  disabled?: boolean;
}

const ProjectSectionInner = ({
  value,
  projects,
  loading,
  onChange,
  errors,
  disabled = false,
}: ProjectSectionProps) => {
  const projectError = errors.length > 0 ? projectInputErrors(value) : '';
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (projectError) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [projectError]);

  return (
    <Box>
      <ScaffolderFormPaper>
        <ScaffolderInputHeader
          title="Project"
          description="Select Deployment as a Service project to assign your Application."
          variant="h5"
          divider
        />
        <div ref={sectionRef}>
          <ProjectPicker
            formData={value}
            projects={projects}
            loading={loading}
            onChange={onChange}
            rawErrors={projectError ? [projectError] : []}
            disabled={disabled}
          />
        </div>
      </ScaffolderFormPaper>
    </Box>
  );
};

export const ProjectSection = memo(ProjectSectionInner);
